import { IonToolbar, IonFooter, IonText } from "@ionic/react";

import "./AppFooter.css";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface ContainerProps {}

const isProduction = process.env.NODE_ENV === "production";

const AppFooter: React.FC<ContainerProps> = () => {
  if (!isProduction) {
    return (
      <IonFooter className="app-footer">
        <IonToolbar>
          <IonText>App Footer</IonText>
        </IonToolbar>
      </IonFooter>
    );
  } else return null;
};

export default AppFooter;
